import React from 'react'
import { ButtonGroup, Col, Container, Row } from 'react-bootstrap'
import DeleteControl from '../controls/DeleteControl'
import BackGroundControl from '../controls/BackGroundControl'
import LockControl from '../controls/LockControl'
import ScaleControl from '../controls/ScaleControl'
import DrawSectorControl from '../controls/DrawSectorControl'
import GomElementsMenu from './GomElementsMenu'
import DragControl from '../controls/DragControl'
import DrawFreeHandControl from '../controls/DrawFreeHandControl'

const ActionsMenu = ({ containerRef, canvasRef, onChangeMapIndex, onClear }) => {
    return (
        <Container
            className="p-0"
            aria-label="Canvas actions control"
            style={{
                position: 'absolute',
                top: '100px',
                left: '10px',
                display: 'inline-block', // Asegura que el tamaño se ajuste al contenido
                maxWidth: 'none', // Elimina restricciones de ancho
                width: 'auto', // No ocupará más espacio del necesario
            }}
        >
            <Row>
                <Col>
                    <ButtonGroup
                        vertical
                        size='sm'
                        style={{
                            border: '1px solid #ddd', // Borde gris
                            borderRadius: '6px',     // Bordes redondeados    
                        }}
                    >
                        <LockControl canvasRef={canvasRef} />

                        <DragControl canvasRef={canvasRef} />

                        <ScaleControl canvasRef={canvasRef} />

                        <BackGroundControl parentNode={containerRef} canvasRef={canvasRef} onMapSelection={onChangeMapIndex} />

                    </ButtonGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ButtonGroup
                        vertical
                        size='sm'
                        className='mt-2'
                        style={{
                            border: '1px solid #ddd', // Borde gris
                            borderRadius: '6px',     // Bordes redondeados    
                        }}
                    >
                        <DrawSectorControl parentNode={containerRef} canvasRef={canvasRef} />

                        <DrawFreeHandControl parentNode={containerRef} canvasRef={canvasRef} />

                        <GomElementsMenu parentNode={containerRef} canvasRef={canvasRef} />

                        {/*<DeleteControl parentNode={containerRef} canvasRef={canvasRef} onClear={onClear} /> */}

                    </ButtonGroup>
                </Col>
            </Row>
        </Container>
    )
}

export default ActionsMenu